import { render, staticRenderFns } from "./PlateNumberOrVinPopup.vue?vue&type=template&id=539887da&scoped=true&"
import script from "./PlateNumberOrVinPopup.vue?vue&type=script&lang=ts&"
export * from "./PlateNumberOrVinPopup.vue?vue&type=script&lang=ts&"
import style0 from "./PlateNumberOrVinPopup.vue?vue&type=style&index=0&id=539887da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539887da",
  null
  
)

export default component.exports